var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcDomain = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qewqeqweqweqwfsdfsadf",
    d: "M10 4V0H0v18h20V4H10zM4 16H2v-2h2v2zm0-4H2v-2h2v2zm0-4H2V6h2v2zm0-4H2V2h2v2zm4 12H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V6h2v2zm0-4H6V2h2v2zm10 12h-8v-2h2v-2h-2v-2h2V8h-2V6h8v10zm-2-8h-2v2h2V8zm0 4h-2v2h2v-2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vzcxzvxcvcxzvxz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qewqeqweqweqwfsdfsadf"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BEC4CA",
    mask: "url(#vzcxzvxcvcxzvxz)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V50H0z",
    transform: "translate(-15 -16)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDomain, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-domain.c2533c07.svg";
export { ForwardRef as ReactComponent };